export default {
    state: {
        wallet: undefined
    },
    getters: {
        wallet: state => state.wallet,
        expenses: (state, getters) => getters.wallet && getters.wallet.data.expenses,
        salaries: (state, getters) => getters.wallet && getters.wallet.data.salaries,
    },
    mutations: {
        wallet(state, wallet) {
            console.log(wallet);
            state.wallet = wallet;
        }
    }
}